module.exports = __webpack_public_path__ + "121d7b8f1d8e0c2fcb92a9922c004205.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_2-320.webp.png
// module id = 291
// module chunks = 0